import { Typography } from '@mui/material';
import { getRegionsDisplay } from 'shared/utils';
import { Flooding } from 'features/flooding/flooding.types';
import { GeoEventUpdateTime } from 'features/geoEvents/components/GeoEventUpdateTime';

type FloodingEmbedContentProps = {
  geoEvent: Flooding;
};

export const FloodingEmbedContent = ({
  geoEvent,
}: FloodingEmbedContentProps): JSX.Element => {
  const {
    data: { areaImpacted },
    regions,
  } = geoEvent;

  return (
    <>
      {Boolean(areaImpacted) && <Typography>{areaImpacted}</Typography>}

      <Typography variant="body2" color="textSecondary">
        {getRegionsDisplay(regions)}
      </Typography>

      <GeoEventUpdateTime geoEvent={geoEvent} sx={{ mb: '-16px !important' }} />
    </>
  );
};
